import { View, Text } from "@react-pdf/renderer";
import { COLORS, styles } from "../../../../forms/pdf-components/PdfStyles";
import { PdfH2 } from "../../../../forms/pdf-components/PdfText";
import {
    PdfRow,
    PdfCol,
    PdfVerticalDivider,
} from "../../../../forms/pdf-components/PdfLayout";
import { PdfDataField } from "../../../../forms/pdf-components/PdfDataField";
import { getPharmacistInfo, getPharmacyInfo } from "../../../common/getPharmacyInfo";

const CLINICAL_SERVICE_DISPLAY_NAMES = {
    annualmedicationreview: "Annual Medication Review",
    medicationreview: "Annual Medication Review",
    allergicrhinitis: "Allergic Rhinitis",
};

const resolveServiceDisplayName = (value) => {
    if (!value) return "";
    const key = String(value).toLowerCase().replace(/[\s_-]/g, "");
    return CLINICAL_SERVICE_DISPLAY_NAMES[key] || value;
};

/**
 * PdfInterventionPatientSections
 *
 * Props:
 *   clinicalServiceName — raw service type string (e.g. "AnnualMedicationReview")
 *   documentation       — formRoot?.notification object
 */
export const PdfInterventionPatientSections = ({
    clinicalServiceName = "",
    documentation = {},
    serviceDate = "",
    pharmacyPhone = "",
    pharmacyEmail = "",
    pharmacistLicenseNumber = "",
    currentLoggedInUserDetail = null,
    pharmacyStores = [],
}) => {
    const provider =
        Array.isArray(documentation?.notificationInformations) &&
            documentation.notificationInformations.length > 0
            ? documentation.notificationInformations[0]
            : null;

    const providerName = provider
        ? [provider.lastName, provider.firstName, provider.middleName]
            .filter(Boolean)
            .join(" ")
        : "";

    const designation = provider?.designation || provider?.title || "";
    const pharmacist = getPharmacistInfo(currentLoggedInUserDetail) ?? {};
    const pharmacy = getPharmacyInfo(currentLoggedInUserDetail, pharmacyStores) ?? {};
    const phone =
        pharmacy?.pharmacyPhone || pharmacyPhone || provider?.phoneNumber || provider?.telephone || provider?.primaryPhone || "";
    const email = pharmacy?.pharmacyEmail || pharmacyEmail || provider?.emailAddress || provider?.email || "";
    const licence =
        pharmacist?.pharmacistLicenseNumber || pharmacistLicenseNumber || provider?.licenseNumber || provider?.license || provider?.licenceNumber || "";

    const displayServiceName =
        resolveServiceDisplayName(clinicalServiceName) || "Patient Chart";

    return (
        <View style={{ display: "flex", flexDirection: "column" }}>
            {!!serviceDate && (
                <Text style={[styles.serviceDate, { textAlign: "right", marginBottom: 6, marginTop: -4 }]}>
                    Service Date: {serviceDate}
                </Text>
            )}
            <View
                style={{
                    borderWidth: 1,
                    borderColor: COLORS.border,
                    backgroundColor: COLORS.bgSection,
                }}
            >
                <PdfRow>
                    {/* Left col — Name of Service */}
                    <PdfCol style={{ padding: 6 }}>
                        <PdfDataField label="Name of Service:" value={displayServiceName} />
                        <PdfDataField label="To:" value={providerName || designation || ""} />
                        <View style={{ flexDirection: "row", flexWrap: "wrap", marginTop: 2 }}>
                            <Text style={styles.inlineBold}>After an assessment for:&nbsp;</Text>
                            <Text style={styles.inlineBold}>[{displayServiceName}]</Text>
                            <Text style={styles.inlineRegular}>
                                , a drug therapy problem was identified.
                            </Text>
                        </View>
                    </PdfCol>

                    <PdfVerticalDivider style={{ marginVertical: 6 }} />

                    {/* Right col — Prescriber Information */}
                    <PdfCol style={{ padding: 6 }}>
                        <PdfH2 style={{ marginBottom: 3 }}>Prescriber Information</PdfH2>
                        <PdfDataField label="Primary Phone number:" value={phone} />
                        <PdfDataField label="Email Address:" value={email} />
                        <PdfDataField label="Licence Number:" value={licence} />
                    </PdfCol>
                </PdfRow>
            </View>
        </View>

    );
};
